import React, { useCallback, useState, useEffect } from 'react';
import Connect from '@store/connect';
import { Button, Toast, Form, Input } from 'antd-mobile';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './index.scss';

const SelfInfo = () => {
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [disable, setDisable] = useState(false);
    const [time, setTime] = useState(0);
    const onFinish = useCallback(async values => {
        const res = await axios.post('/api/bid/check-sms-code', {
            ...values,
        });
        if (res.data.status) {
            sessionStorage.setItem('ciphertext', res.data.data.ciphertext);
            navigate('/self-result');
        } else {
            Toast.show({
                icon: 'fail',
                content: '验证失败',
            });
        }
    }, []);
    const sendCode = async () => {
        const { phone } = form.getFieldsValue();
        if (/^1[3|4|5|7|8|9][0-9]{9}$/.test(phone)) {
            const r = await axios.get(`/api/bid/get-sms-code?tel=${phone}`);
            if (r.data.status) {
                Toast.show({
                    icon: 'success',
                    content: '发送成功',
                });
                setDisable(true);
                setTime(60);
            } else {
                Toast.show({
                    icon: 'fail',
                    content: '发送失败请稍候',
                });
            }
        } else {
            Toast.show({
                icon: 'fail',
                content: '手机号非法',
            });
        }
    };
    useEffect(() => {
        setTimeout(() => {
            if (time > 0) {
                setTime(time - 1); // 在这不依赖于外部的 `count` 变量
            } else {
                setDisable(false);
            }
        }, 1000);
    }, [time]);
    return (
      <>
        <div className="header">南京苏宁咨询招标(采购)平台</div>
        <Form
                name="form"
                form={form}
                style={{ marginTop: '4rem' }}
                onFinish={onFinish}
                footer={
                  <Button block type="submit" color="primary">
                        招投标(采购)查询
                  </Button>
                }
            >
          <Form.Item
                    name="phone"
                    label="手机号"
                    help="请输入11位手机号作为联系方式"
                >
            <Input placeholder="请输入手机号" />
          </Form.Item>
          <Form.Item
                    name="password"
                    label="验证码(6位)"
                    help="请输入6位验证码"
                    className="form-item"
                    extra={
                      <Button
                            color="primary"
                            className="item-btn"
                            onClick={sendCode}
                            disabled={disable}
                        >
                        {disable ? `发送中(${time}s)` : '发送验证码'}
                      </Button>
                    }
                >
            <Input placeholder="请输入验证码" />
          </Form.Item>
        </Form>
      </>
    );
};

SelfInfo.propTypes = {};

const mapStateToProps = () => {};

export default Connect(mapStateToProps)(SelfInfo);
